import { __makeTemplateObject } from "tslib";
import React from 'react';
import styled from 'styled-components';
import Hotspot from '../containers/Hotspot';
export default function FixedHotspotLayer(_a) {
    var hotspots = _a.hotspots, getScreenScrollPos = _a.getScreenScrollPos, screenID = _a.screenID, scrollableAreaRef = _a.scrollableAreaRef, marginLeft = _a.marginLeft;
    return (React.createElement(LayerContainer, { onWheel: function (_a) {
            var deltaY = _a.deltaY, target = _a.target;
            if (target.dataset.propagateScroll === 'false') {
                return;
            }
            // Make the hotspots rendered on this layer scrollable
            if (scrollableAreaRef.current) {
                // eslint-disable-next-line no-param-reassign
                scrollableAreaRef.current.scrollTop += deltaY;
            }
        }, style: { left: marginLeft } }, hotspots.map(function (_a) {
        var id = _a.id, location = _a.location;
        return (React.createElement(Hotspot, { getScreenScrollPos: getScreenScrollPos, id: id, key: id, location: location, screenID: screenID }));
    })));
}
var LayerContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n"], ["\n  position: absolute;\n  top: 0;\n"])));
var templateObject_1;
